
import { FileCheckAttribute, Msg, FileUploadStatus, FileTableRow } from "./Types.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Loading_Circle from "../../../public/assets/icons/Loading_Circle.svg";
import { empty as empty_1, toArray, singleton as singleton_1, map as map_2, append as append_1, length, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import Delete_Circle from "../../../public/assets/icons/Delete_Circle.svg";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { DocumentFileCheck_FileCheckEntityType__ToI18nString } from "../../Shared/Importer.js";
import { createElement } from "react";
import React from "react";
import { Button, TextButton, IconButton } from "../../Components/Button.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { useTranslation } from "react-i18next";
import { nativeType, useDrop } from "../../Bindings/Fable.ReactDnD.js";
import { map as map_1, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import { TextValue } from "../../Components/Text.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { ErrorAlert, InformationAlert } from "../../Components/Alert.js";
import { Select } from "../../Components/Select.js";
import { Checkbox } from "../../Components/Checkbox.js";
import Magnifying_Glass from "../../../public/assets/icons/Magnifying_Glass.svg";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";

function toTableRow(selectedFile) {
    let patternInput;
    const matchValue = selectedFile.ValidationStatus;
    patternInput = ((matchValue.tag === 1) ? [matchValue.fields[0], matchValue.fields[1], matchValue.fields[2]] : [undefined, undefined, undefined]);
    return new FileTableRow(selectedFile.Id, selectedFile.File.name, selectedFile.ValidationStatus, patternInput[0], patternInput[1], patternInput[2], selectedFile.UploadStatus);
}

function UploadStatusIcon(status) {
    let elems, elems_1, elems_2;
    switch (status.tag) {
        case 1:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-primary", "animate-spin"])], (elems = [Loading_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        case 2:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-green"])], (elems_1 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        case 3:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-red"])], (elems_2 = [Delete_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        default:
            return defaultOf();
    }
}

function createColumnDefinitions(t, dispatch, isUploading) {
    return [new ColumnDefinition$1("fileName", "", t("general.file_name"), (row) => (new CellContent(0, [row.FileName])), "none", "text"), new ColumnDefinition$1("validationStatus", "", t("importer.documents.check_status"), (row_1) => {
        let matchValue;
        return new CellContent(0, [(matchValue = row_1.ValidationStatus, (matchValue.tag === 2) ? t("importer.documents.check_failed") : ((matchValue.tag === 0) ? t("importer.documents.not_checked_yet") : t("importer.documents.check_successful")))]);
    }, "select", "text"), new ColumnDefinition$1("entityType", "", t("importer.documents.entity_type"), (row_2) => (new CellContent(0, [t(defaultArg(map(DocumentFileCheck_FileCheckEntityType__ToI18nString, row_2.EntityType), ""))])), "select", "text"), new ColumnDefinition$1("entityName", "", t("importer.documents.entity_name"), (row_3) => (new CellContent(0, [defaultArg(row_3.EntityName, "-")])), "none", "text"), new ColumnDefinition$1("uploadStatus", "", t("importer.documents.upload_status"), (row_4) => (new CellContent(1, [UploadStatusIcon(row_4.UploadStatus)])), "none", "text"), new ColumnDefinition$1("actions", "", "", (row_5) => (new CellContent(1, [(!isUploading && equals(row_5.UploadStatus, new FileUploadStatus(0, []))) ? createElement(IconButton, {
        ComponentState: "enabled",
        Icon: Delete_1(),
        OnClick: () => {
            dispatch(new Msg(1, [row_5.Id]));
        },
        TestId: concat("remove-file-", ...row_5.Id),
    }) : defaultOf()])), "none", "text")];
}

function DropArea(props) {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let files;
            const matchValue = draggedFile.files;
            let matchResult, files_1;
            if (matchValue != null) {
                if ((files = matchValue, files.length > 0)) {
                    matchResult = 0;
                    files_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    props.OnFilesSelected(ofArray(files_1));
                    break;
                }
                case 1: {
                    break;
                }
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border"), delay(() => append(singleton("rounded"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => append(singleton("p-8"), delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => ((dropData.isOver && dropData.canDrop) ? singleton("bg-background") : empty()))))))))))))))))))))))], ["ref", patternInput_1[1]], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-12", "w-12", "text-primary", "mb-4"])], (elems = [Upload_File()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("importer.documents.drag_drop_hint"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = [createElement(TextButton, {
        ComponentState: props.ComponentState,
        Label: t("file_upload.select_file"),
        OnClick: () => {
            const element = document.getElementById("document-file-upload");
            element.click();
        },
        TestId: "open-file-explorer-test-id",
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("input", {
        id: "document-file-upload",
        className: join(" ", ["hidden"]),
        type: "file",
        multiple: true,
        onChange: (ev) => {
            const fileList = ev.target.files;
            if (!(fileList == null)) {
                const files_2 = toList(delay(() => map_1((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1))));
                if (length(files_2) > 0) {
                    props.OnFilesSelected(files_2);
                }
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function attributeToSelectOption(t, attr) {
    switch (attr.tag) {
        case 1:
            return {
                label: t("general.inventory_number"),
                value: attr,
            };
        case 2:
            return {
                label: attr.fields[0].Name,
                value: attr,
            };
        default:
            return {
                label: t("tool.serial_number"),
                value: attr,
            };
    }
}

function getSelectedOption(t, attr) {
    return attributeToSelectOption(t, attr);
}

function createCheckAttributeOptions(t, propertyConfigurations) {
    return append_1(ofArray([{
        label: t("tool.serial_number"),
        value: new FileCheckAttribute(0, []),
    }, {
        label: t("general.inventory_number"),
        value: new FileCheckAttribute(1, []),
    }]), map_2((pc) => ({
        label: pc.Name,
        value: new FileCheckAttribute(2, [pc]),
    }), propertyConfigurations));
}

function DropzoneView(props) {
    let elems_6;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : ((props.State.UploadStatus.tag === 1) ? "disabled" : "enabled");
    const checkAttributeOptions = createCheckAttributeOptions(t, props.PropertyConfigurations);
    const selectedCheckAttributeOption = getSelectedOption(t, props.State.SelectedCheckAttribute);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "max-w-[75rem]"])], (elems_6 = toList(delay(() => {
        let elems_5;
        return append(singleton(createElement(SectionContainer, {
            Content: reactElement("div", createObj(singleton_1((elems_5 = toList(delay(() => append(singleton(createElement(InformationAlert, {
                Label: "importer.documents.info",
            })), delay(() => {
                let elems;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "max-w-md"])], (elems = [createElement(Select, {
                    ComponentState: componentState,
                    IsClearable: false,
                    Label: t("importer.documents.check_attribute"),
                    NoOptionsMessage: "general.no_data",
                    OnChange: (option) => {
                        if (option == null) {
                        }
                        else {
                            props.Dispatch(new Msg(7, [option.value]));
                        }
                    },
                    Options: checkAttributeOptions,
                    PlaceholderKey: "importer.select_check_attribute",
                    TestId: "check-attribute-select",
                    Value: selectedCheckAttributeOption,
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                    let elems_1;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = [createElement(DropArea, {
                        ComponentState: componentState,
                        OnFilesSelected: (files) => {
                            props.Dispatch(new Msg(0, [files]));
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                        let elems_2;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_2 = [Checkbox({
                            ComponentState: componentState,
                            IsChecked: props.State.IsVisibleForUserRole,
                            Label: t("importer.documents.visible_for_user_role"),
                            OnCheck: (_arg) => {
                                props.Dispatch(new Msg(8, [!props.State.IsVisibleForUserRole]));
                            },
                            TestId: "visible-for-user-role-checkbox",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                            let elems_4, elems_3, Label_2, Label_3;
                            return (length(props.State.SelectedFiles) > 0) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-2", "mt-4"])], (elems_3 = [createElement(Button, (Label_2 = t("importer.documents.check_files"), {
                                ComponentState: componentState,
                                Icon: Magnifying_Glass(),
                                Label: Label_2,
                                OnClick: () => {
                                    props.Dispatch(new Msg(2, []));
                                },
                                TestId: "check-documents-btn",
                                Variant: "secondary",
                            })), createElement(Button, (Label_3 = t("general.upload"), {
                                ComponentState: componentState,
                                Icon: Upload_File(),
                                Label: Label_3,
                                OnClick: () => {
                                    props.Dispatch(new Msg(3, []));
                                },
                                TestId: "upload-documents-btn",
                                Variant: "primary",
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty();
                        }));
                    }));
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])))),
            Title: "importer.documents.header",
        })), delay(() => {
            let Title_2, Title_1;
            const matchValue_1 = props.State.UploadStatus;
            switch (matchValue_1.tag) {
                case 3:
                    return singleton(createElement(SectionContainer, (Title_2 = t("importer.documents.upload_failed"), {
                        Content: createElement(ErrorAlert, {
                            Label: matchValue_1.fields[0],
                        }),
                        Title: unwrap(Title_2),
                    })));
                case 0:
                case 1:
                    return singleton(defaultOf());
                default:
                    return singleton(createElement(SectionContainer, (Title_1 = t("importer.documents.uploaded_documents"), {
                        Content: createElement(InformationAlert, {
                            Label: "importer.documents.uploaded_success",
                        }),
                        Title: unwrap(Title_1),
                    })));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function View(props) {
    let elems_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const isUploading = state_1.UploadStatus.tag === 1;
    const tableRows = toArray(map_2(toTableRow, state_1.SelectedFiles));
    const columnDefinitions = createColumnDefinitions(patternInput_1[0], dispatch, isUploading);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = toList(delay(() => {
        const matchValue_1 = state_1.PropertyConfigurations;
        return (matchValue_1.tag === 0) ? singleton(createElement(Skeleton, {
            Variant: "normal",
        })) : append(singleton(createElement(DropzoneView, {
            Dispatch: dispatch,
            FormState: state_1.FormState,
            PropertyConfigurations: matchValue_1.fields[0],
            State: state_1,
        })), delay(() => {
            let elems;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = [createElement(InfiniteTable, {
                ColumnDefinitions: columnDefinitions,
                Controls: empty_1(),
                Options: {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["fileName", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "disabled",
                    SaveTableConfiguration: false,
                    WithQueryParameters: false,
                },
                TableKey: "document-import-files",
                TableRows: tableRows,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

